import { Link, useNavigate } from "react-router-dom";
import { BiSolidHome } from "react-icons/bi";
import { AiFillInfoCircle } from "react-icons/ai";
import { IoSchool } from "react-icons/io5";
import {
  FaCalendar,
  FaChalkboardTeacher,
  FaEuroSign,
  FaListUl,
  FaUserCircle,
} from "react-icons/fa";
import { Button, NavDropdown } from "react-bootstrap";
import { useAuth } from "authContext";
import { toast } from "react-toastify";
import NavItem from "./NavItem";
import { MdDashboard } from "react-icons/md";
import { TbCertificate } from "react-icons/tb";
import { FaPeopleGroup } from "react-icons/fa6";

function SidebarContent({ onLinkClick }: { onLinkClick?: () => void }) {
  const { isAuthenticated, userProfile, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    onLinkClick?.();
    logout();
    toast.success("Uspješno ste se odjavili");
    navigate("/");
  }

  function isPrincipalAccountantTeacher() {
    if (!isAuthenticated) {
      return false;
    }

    const allowedRoles = ["PRINCIPAL", "ACCOUNTANT", "TEACHER"];
    return allowedRoles.includes(userProfile?.role ?? "");
  }

  return (
    <>
      <hr />
      <ul id="sidebar-links-list" className="nav nav-pills flex-column mb-auto">
        <NavItem
          listClass="nav-item"
          to="/"
          label="Naslovna"
          icon={<BiSolidHome className="fs-4" />}
          onLinkClick={onLinkClick}
        />
        <NavItem
          to="o-nama"
          label="O nama"
          icon={<AiFillInfoCircle className="fs-4" />}
          onLinkClick={onLinkClick}
        />
        {isAuthenticated && (
          <NavItem
            to="dashboard"
            label="Dashboard"
            icon={<MdDashboard className="fs-4" />}
            onLinkClick={onLinkClick}
          />
        )}

        {/* Pripreme za maturu group */}
        <li className="nav-item mt-3 mb-2">
          <span className="text-uppercase fw-bold text-muted ps-3">
            Pripreme za maturu
          </span>
        </li>
        <NavItem
          listClass="nav-item"
          to="/pripreme-za-maturu"
          label="O pripremama"
          icon={<BiSolidHome className="fs-4" />}
          onLinkClick={onLinkClick}
        />
        <NavItem
          to="/cjenik"
          label="Cjenik"
          icon={<FaEuroSign className="fs-4" />}
          onLinkClick={onLinkClick}
        />
        <NavItem
          to="/nastavnici"
          label="Nastavnici"
          icon={<IoSchool className="fs-4" />}
          onLinkClick={onLinkClick}
        />
        <NavItem
          to="prijava-pripreme-drzavna-matura"
          label="Prijava Priprema"
          icon={<TbCertificate className="fs-4" />}
          onLinkClick={onLinkClick}
        />
        {isAuthenticated ? (
          <>
            {(userProfile?.role === "PRINCIPAL" ||
              userProfile?.role === "CLERK") && (
              <>
                <NavItem
                  to="prijave"
                  label="Prijave admin"
                  icon={<FaListUl className="fs-4" />}
                  onLinkClick={onLinkClick}
                />
                <NavItem
                  to="grupe-admin"
                  label="Grupe admin"
                  icon={<FaPeopleGroup className="fs-4" />}
                  onLinkClick={onLinkClick}
                />
                <NavItem
                  to="predmeti"
                  label="Predmeti admin"
                  icon={<IoSchool className="fs-4" />}
                  onLinkClick={onLinkClick}
                />
                <NavItem
                  to="nastavnici-admin"
                  label="Nastavnik admin"
                  icon={<FaChalkboardTeacher className="fs-4" />}
                  onLinkClick={onLinkClick}
                />
              </>
            )}
          </>
        ) : (
          <></>
        )}

        {/* Poduke group */}
        <li className="nav-item mt-4 mb-2">
          <span className="text-uppercase fw-bold text-muted ps-3">Poduke</span>
        </li>
        <NavItem
          listClass="nav-item"
          to="/poduke"
          label="O podukama"
          icon={<BiSolidHome className="fs-4" />}
          onLinkClick={onLinkClick}
          end={true}
        />
        <NavItem
          to="/poduke/cjenik"
          label="Cjenik"
          icon={<FaEuroSign className="fs-4" />}
          onLinkClick={onLinkClick}
        />
        <NavItem
          to="/poduke/rezervacija"
          label="Rezervacija poduka"
          icon={<AiFillInfoCircle className="fs-4" />}
          onLinkClick={onLinkClick}
        />
        <NavItem
          to="/poduke/nastavnici"
          label="Nastavnici"
          icon={<IoSchool className="fs-4" />}
          onLinkClick={onLinkClick}
        />
        {isAuthenticated &&
          (userProfile?.role === "PRINCIPAL" ||
            userProfile?.role === "ACCOUNTANT") && (
            <>
              <NavItem
                to="/poduke/predmeti"
                label="Predmeti admin"
                icon={<IoSchool className="fs-4" />}
                onLinkClick={onLinkClick}
              />
              <NavItem
                to="/poduke/nastavnici-admin"
                label="Nastavnik admin"
                icon={<FaChalkboardTeacher className="fs-4" />}
                onLinkClick={onLinkClick}
              />
            </>
          )}
        {isPrincipalAccountantTeacher() && (
          <NavItem
            to="/poduke/kalendar"
            label="Kalendar"
            icon={<FaCalendar className="fs-4" />}
            onLinkClick={onLinkClick}
          />
        )}
      </ul>
      <hr />
      <div className="dropdown">
        {isAuthenticated ? (
          <div className="d-flex align-items-center justify-content-center text-decoration-none fw-bold">
            <FaUserCircle className="fs-2 me-3" />
            <NavDropdown
              title={userProfile?.first_name || "Korisnik"}
              id="basic-nav-dropdown"
            >
              <NavDropdown.Item onClick={handleLogout}>
                Odjavi se
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        ) : (
          <div
            id="login-buttons"
            className="d-flex justify-content-around align-items-center"
            style={{ flex: 1, gap: "7px" }}
          >
            <div>
              <Link to="prijava" onClick={onLinkClick}>
                <Button variant="outline-primary" className="px-4">
                  Login
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default SidebarContent;
